<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger partnerabonnementspris</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <h4>
      {{ partnerSubscriptionTypeMapping.partnerSubscriptionTypeId + ' - ' + partnerSubscriptionTypeMapping.partnerName }}
    </h4>
    <h5>{{ partnerSubscriptionTypeMapping.subscriptionTypeName + ' - ' + partnerSubscriptionTypeMapping.kundesegment }}</h5>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Ny pris</mat-label>
        <input formControlName="newPartnerPrice" matInput />
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Aktuel pris</mat-label>
        <input [value]="form.value.partnerPrice" matInput disabled />
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Tidligere pris</mat-label>
        <input [value]="form.value.previousPartnerPrice" matInput disabled />
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="save()">Gem</button>
</div>
